import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = { class: "block text-sm font-medium text-gray-700" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
export default /*@__PURE__*/ _defineComponent({
    __name: 'InputLabel',
    props: {
        value: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("label", _hoisted_1, [
                (__props.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.value), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_3, [
                        _renderSlot(_ctx.$slots, "default")
                    ]))
            ]));
        };
    }
});
